import { ConfigService } from './../config-service/config.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPhysicalLocation } from '@stockcare-models/IPhysical-location';

@Injectable({
    providedIn: 'root'
})
export class PhysicalLocationsService {
    constructor(private http: HttpClient, private conf: ConfigService) {}

    getByInstitution(institutionId: number): Observable<IPhysicalLocation[]> {
        return this.http.get<IPhysicalLocation[]>(
            `${
                this.conf.config.baseUrl
            }/physicallocations/institution/${institutionId}`
        );
    }
}
